import { InputAdornment, makeStyles, TextField } from '@material-ui/core';
import themes from 'constants/themes';
import React, { useRef, useState } from 'react';
import {
    checkCategoryFilter,
    searchCategoryFilter,
    setCategorySearchTerm,
    IFilterItem,
} from 'redux/filter/filterSlice';
import { RootState, useAppDispatch, useAppSelector } from 'redux/store';
import { StyledSelectOption } from 'component/StandardDropDownCheckBox';
import { ReactComponent as SearchIcon } from 'assets/svg/search.svg';
import { debounce } from 'lodash';
import utils from 'utils/utils';

const FilterCategoryWidget = ({ setTriggerUpdateSearch }) => {
    const classes = useStyles();
    const dispatch = useAppDispatch();
    const { categoryFilterList, categorySearchTerm } = useAppSelector((state: RootState) => state.filter);
    const [searchTerm, setSearchTerm] = useState(categorySearchTerm);

    const handleChangeCategoryFilter = (item: IFilterItem<string>) => {
        dispatch(checkCategoryFilter(item));
        setTriggerUpdateSearch(true);
    };

    const debounceSearch = useRef(
        debounce((value) => {
            dispatch(setCategorySearchTerm(value));
            dispatch(searchCategoryFilter(value.trim()));
        }, 300),
    ).current;

    const onSearchCategory = (event) => {
        const value = event.target.value;
        setSearchTerm(value);
        debounceSearch(value);
    };

    return (
        <div className={classes.sortWrap}>
            <TextField
                className={classes.input}
                placeholder={'Search'}
                onChange={onSearchCategory}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                }}
                defaultValue={searchTerm}
            />
            {categoryFilterList
                .filter((i) => i.isShow)
                .map((item: IFilterItem<string>) => (
                    <StyledSelectOption
                        key={item.value}
                        label={utils.capitalizeString(item.title)}
                        value={item.value}
                        isActive={item.isActive || false}
                        handleChange={() => handleChangeCategoryFilter(item)}
                        style={{ padding: 0 }}
                    />
                ))}
        </div>
    );
};

export default FilterCategoryWidget;

const useStyles = makeStyles(() => ({
    sortWrap: {
        marginTop: 20,
    },
    filterTitle: {
        marginTop: 24,
        fontSize: 18,
        fontWeight: 600,
        color: themes.palette.primary.main,
    },
    selectedItem: {
        background: themes.palette.secondary['500'],
    },
    input: {
        width: '100%',
        marginBottom: '16px',
        '& .MuiInputBase-root': {
            padding: '6px 0',
        },
        '& .MuiInput-underline': {
            '&.Mui-focused': {
                bottom: 0,
                borderBottom: 'none',
            },
            '&:before': {
                borderBottom: '1px solid #BBC8CA',
            },
            '&:after': {
                borderBottom: 'none',
            },
        },
        '&.Mui-focused::before': {
            borderBottom: '1px solid #BBC8CA',
        },
        '& input.MuiInputBase-input': {
            fontFamily: 'PoppinsRegular',
            fontSize: 16,
            fontWeight: 400,
            '&::placeholder': {
                color: themes.palette.primary.main,
            },
        },
    },
}));
